<template>
  <div class="my-page-component">
    <div class="inner">
      <Login @login="login" @logout="logout" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/classes/API';
import Login from '@/components/payments/Login';

export default {
  data() {
    return {
      orders: [],
      user: {},
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    activeTab() {
      return this.$route.meta.page;
    },
  },
  methods: {
    async fetch() {
      const endpoint = this.$route.query.admin ? '/admin/user' : '/account/user';
      try {
        const { user } = await API.get(endpoint);
        if (user) {
          this.user = user;
        }
      } catch (e) {
        // Ignore session loading error
      }
    },
    login() {
      this.fetch();
      if (this.$store.state.user.isAdmin) {
        this.$router.push('/admin');
      } else {
        this.$router.push('/mina-sidor');
      }
    },
    logout() {
      this.$router.push('/');
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
@import '~@/global-v2.styl'

.my-name
  font-size: 13px;
  font-weight: 300;
  text-align: center;
  color: #262626;
  padding 15px
  border-bottom solid 1px #ececec;

.login
  padding 50px

.my-page-component
  min-height 80vh
  background-color white
  padding: 2rem
  padding-top 3rem
  width: 100%
  display: block

.tab-wrapper
  padding 20px 25px

.inner
  background-color white
  max-width 936px
  margin 0 auto
  .tab-buttons
    display flex
    border-radius: 4px;
    background-color: #ecf5f8;

    .tab-button
      flex-grow: 1;
      width: 20%;
      text-align center
      padding-top 20px
      height 92px
      cursor pointer
      border-right: 3px solid #fff;
      &:last-child
        border-right: 0px solid #fff

      &.active
        background-color #005580

      .icon
        margin-bottom 5px



      span
        display block
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        line-height: 1.1em
        uppercase()
        color: #262626;
        +max-mobile()
          font-size: 9px;
      &.active
        span
          color white

.icon-on-mobile
  display none
.icon-on-desktop
  display: inline-block
+max-mobile()
  .icon-on-mobile
    display inline-block
  .icon-on-desktop
    display: none
</style>



// WEBPACK FOOTER //
// LoginPage.vue?4527c2b8